import { render, staticRenderFns } from "./TypeSubmission.vue?vue&type=template&id=4b2cfbce&scoped=true&"
import script from "./TypeSubmission.vue?vue&type=script&lang=js&"
export * from "./TypeSubmission.vue?vue&type=script&lang=js&"
import style0 from "./TypeSubmission.vue?vue&type=style&index=0&id=4b2cfbce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2cfbce",
  null
  
)

export default component.exports